import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { isEqual } from 'lodash'
import { connect } from 'react-redux'
import { getOrder, setOrder, resetOrder, setLastVisitedOrderId } from '../../../actions/orders'
import { resetPrice } from '../../../actions/price'
import { setPageTitle } from '../../../actions/common'
import { getMatchingSpareParts } from '../../../actions/dracar'

// import styles
import './order.scss'

// import components
// import Header from '../../../shared/components/Header'

// Elements
import TabItem from '../../../shared/elements/tabItem'
import Icon from '../../../shared/elements/icon'
// import Null from '../../../shared/elements/null'
import { ElementIcons } from '../../../shared/elements/icons'

// Utils
import { makeOrderPageTitleObject } from '../../../utils/order'
import { hasSubscriptionPermission, hasAccess, hasPartnerSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'
import { shouldHaveArrow } from '../../../utils/router'

// Tabs
import WorkCard from './NewWorkCard'
import Documentation from './Documentation'
import Log from './Log'
import TabBar from '../../../shared/elements/tabBar'
import CloseButton from '../../../shared/elements/closeButton'

class Order extends Component {

  constructor (props) {
    super(props)
    this.state = {
      tabActive: 'workcard',
      createdNew: false
    }
    this.renderTitle = this.renderTitle.bind(this)
    this.onUpdateOrder = this.onUpdateOrder.bind(this)
    // this.renderButtonsGoBack = this.renderButtonsGoBack.bind(this)
    this.renderTabs = this.renderTabs.bind(this)
    this.fetchOrder = this.fetchOrder.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState)
  }

  componentWillReceiveProps (nextProps) {
    // Handle load of new order when order Id in props changes.
    if (typeof nextProps.params.orderID === 'string' && this.props.params.orderID !== nextProps.params.orderID) {
      this.props.resetOrder()
      this.props.resetPrice()
      this.fetchOrder(nextProps.params)
      this.setState({
        tabActive: 'workcard'
      })
    }
  }

  componentWillMount () {
    if (this.props.location.state !== undefined) {
      if (this.props.location.state) {
        const { createdNew, bookingDestination, assignments } = this.props.location.state
        this.setState({
          createdNew: createdNew,
          bookingDestination: bookingDestination,
          assignments: assignments
        })
      }
      // if (this.props.location.state.createdNew) {
      //   this.setState({
      //     createdNew: true
      //   })
      // }
      let location = {
        ...this.props.location,
        state: undefined
      }
      this.props.router.replace(location)
    }

    this.props.resetOrder()
    this.props.resetPrice()

    this.fetchOrder(this.props.params)

    // this.props.getMatchingSpareParts({ OrderId: this.props.params.orderID, CheckInvoiceActive: true })
    // .then(() => {
    //   this.fetchOrder(this.props.params)
    // })
    // .catch(() => {
    //   // Incase the fetching of spareparts fails, we still want to try and retrieve the Order
    //   this.fetchOrder(this.props.params)
    // })

    let tab = this.props.router.location.query.page
    if (tab) {
      switch (tab) {
        case '1':
          tab = 'workcard'
          break
        case '2':
          tab = 'documentation'
          break
        case '3':
          tab = 'log'
          break
      }
      const location = this.props.router.location
      delete location.query.page
      this.props.router.replace(location)

      this.setState({
        tabActive: tab
      })
    }
  }

  fetchOrder (params) {
    this.props.getOrder(params.orderID).then(res => {
      this.props.setPageTitle(makeOrderPageTitleObject(res.data))
    })
  }

  changeTab (title, e) {
    e.preventDefault()
    this.setState({
      tabActive: title.val
    })
  }

  renderTitle (title, index) {
    let activeClass = (this.state.tabActive === title.val ? 'active' : '')
    let onClick = this.changeTab.bind(this, title)
    let link = '#'
    if (title.link) {
      link = title.link
      onClick = () => { }
    }
    return (
      <TabItem key={'tab_' + index}>
        <Link
          className={activeClass}
          to={link}
          onClick={onClick}>
          {title.name}
        </Link>
      </TabItem>
    )
  }

  renderTabs () {
    let isCustomer = this.props.auth.user.CustomerId !== '-1'
    let isBodyShop = this.props.auth.user.ShopId !== '-1' && this.props.auth.user.DepartmentType === 1
    // Tab titles
    let titles = [
      { name: translation('159'), val: 'workcard' }
      // { name: 'Log', val: 'log' }
    ]

    // Show documentation page only to Apromas PRO
    if (hasSubscriptionPermission(this.props.auth, 10, 0) || (hasSubscriptionPermission(this.props.auth, 0) && hasPartnerSubscriptionPermission(this.props.auth, 10))) {
      titles.push(
        { name: translation('1042'), val: 'documentation' }
      )
    }
    // order log
    titles.push(
      { name: translation('2211'), val: 'log' }
    )
    // console.log('isdraft, isbodyshopdraft', this.props.order)
    // Show order inspection only if not customer, not draft and "Quality Control" permission is checked
    if (typeof this.props.order.IsDraft !== 'undefined' && typeof this.props.order.BodyShopIsDraft !== 'undefined' && hasSubscriptionPermission(this.props.auth, 10, 30) && ((!isCustomer && !this.props.order.IsDraft) || (hasAccess([6], this.props.auth.user.UserType) && !this.props.order.IsDraft) || (!isCustomer && isBodyShop && !this.props.order.BodyShopIsDraft))) {
      titles.push(
        { name: translation('13423'), val: null, link: '/orders/' + this.props.params.orderID + '/orderinspection' }
      )
    }
    const renderTitles = () => {
      return titles.map(this.renderTitle)
    }
    return (
      <TabBar>
        {renderTitles()}
      </TabBar>
    )
  }

  renderActivePage () {
    let headerButtonsGoBack
    if (typeof this.props.location.state !== 'undefined') {
      if (typeof this.props.location.state.lastview !== 'undefined') {
        headerButtonsGoBack = (router, t) => {
          const goBack = () => {
            this.props.router.replace({
              pathname: '/workscreen',
              query: {
                view: this.props.location.state.lastview
              }
            })
          }
          // <div className='alignHelper' />
          return (
            <div key={'close'}>
              <div className='hint--left' aria-label={t('2060')}>
                <Icon icon={ElementIcons.Close} onClick={goBack} />
              </div>
            </div>
          )
        }
      }
    } else {
      let routeItem = window.LocalstorageStack.findFirst(['/mypage/orders', '/workscreen', '/orders', '/CarRentals/Overview', 'OrderCapacityOverview'])
      if (routeItem !== null) {
        headerButtonsGoBack = (router, t) => {
          const goBack = () => {
            let query = {}
            if (this.state.bookingDestination) {
              query.destination = this.state.bookingDestination
            }
            if (routeItem.pathname === '/orders') {
              let orderId = this.props.params.orderID
              this.props.setLastVisitedOrderId(orderId)
              query.orderid = orderId
            }

            if (routeItem.pathname === 'OrderCapacityOverview') {
              let orderId = this.props.params.orderID
              if (orderId) {
                let viewState = window.localStorage.getItem('capacity_viewstate')
                try {
                  viewState = JSON.parse(viewState) || {}
                } catch (error) {
                  viewState = {}
                }
                viewState.orderId = parseInt(orderId)
                viewState.openDetails = true
                window.localStorage.setItem('capacity_viewstate', JSON.stringify(viewState))
                console.log('viewState = ', viewState)
              }
              // console.log('OrderCapacityOverview - goBack -> path: ', routeItem.pathname, 'query: ', query, ' orderId: ', orderId)
              this.props.router.replace({
                pathname: routeItem.search,
                query: query
              })

              return
            }
            this.props.router.replace({
              pathname: routeItem.pathname,
              query: query
            })
          }
          const renderArrowBack = () => {
            let topOfStack = window.LocalstorageStack.top()
            if (topOfStack.pathname !== '/CarRental/' && topOfStack.pathname !== '/CarRental') return null
            if (topOfStack && !shouldHaveArrow()) {
              return null
            }
            const goBack = () => {
              this.props.router.replace({
                pathname: '/CarRental'
              })
            }
            return <div className='hint--left' aria-label={translation('394')}><img src='/images/icons/back-white-30x30.png' onClick={goBack.bind(this)} className='icon' /></div>
          }
          return (
            <div key='back_close'>
              {renderArrowBack()}
              <CloseButton onClick={goBack} ariaText={t('2060')} />
            </div>
          )
        }
      }
    }

    switch (this.state.tabActive) {
      case 'documentation':
        return <Documentation
          renderTabs={this.renderTabs}
          renderButtonsGoBack={headerButtonsGoBack}
          router={this.props.router}
          order={this.props.order}
          onUpdateOrder={this.onUpdateOrder}
          />
      case 'log':
        return <Log
          renderTabs={this.renderTabs}
          renderButtonsGoBack={headerButtonsGoBack}
          router={this.props.router}
          onUpdateOrder={this.onUpdateOrder}
          />
      case 'workcard':
      default:
        return <WorkCard
          renderTabs={this.renderTabs}
          renderButtonsGoBack={headerButtonsGoBack}
          router={this.props.router}
          onUpdateOrder={this.onUpdateOrder}
          createdNew={this.state.createdNew}
          bookingDestination={this.state.bookingDestination}
          assignments={this.state.assignments}
          />
    }
  }

  onUpdateOrder (res) {
    if (typeof res === 'undefined' || typeof res === undefined) {
      this.props.getOrder(this.props.params.orderID).then(res => {
        if (/\/orders\/\d{6,}/.test(this.props.router.location.pathname)) {
          // Only change if still on '/orders/xxxxxx'
          this.props.setPageTitle(makeOrderPageTitleObject(res.data))
        }
      })
    } else {
      this.props.setOrder(res)
    }
  }

  renderError () {
    return (
      <div className='order__screen'>
        <div className='white__box notfound'>
          {translation('2229')}: {this.props.params.orderID}
        </div>
      </div>
    )
  }

  // renderButtonsGoBack () {
  //   return headerButtonsGoBack
  // }

  render () {
    if (typeof this.props.order === 'undefined' || this.props.order === null) {
      return this.renderError()
    }

    // Generate title
    // let title = makeOrderTitle(this.props.order, translation, enumtranslate, false, true)
    /*
    let title = ''
    if (this.props.order.Model) {
      title += this.props.order.Model
    }
    if (this.props.order.RegNumber) {
      if (this.props.order.Model) {
        title += ', '
      }
      title += this.props.order.RegNumber
    }
    if (title === '') {
      title = this.props.order.Id
    }
    */

    return (
      <div className='order__screen'>
        <div className='order__screen--inner'>
          {this.renderActivePage()}
        </div>
      </div>
    )
  }

}

Order.propTypes = {
  getOrder: PropTypes.func.isRequired,
  setOrder: PropTypes.func.isRequired,
  resetOrder: PropTypes.func.isRequired,
  resetPrice: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    order: state.orders.order
  }
}

export default connect(mapStateToProps, {
  getOrder,
  setOrder,
  resetOrder,
  resetPrice,
  setPageTitle,
  getMatchingSpareParts,
  setLastVisitedOrderId
}, null, { withRef: true })(Order)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/index.js